export default __webpack_public_path__ + "static/media/logo-dark.1ea13348.png";